import type { SVGProps } from 'react'
const SvgSyForm = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M5.293 5.293C5 5.586 5 6.057 5 7v10c0 1.886 0 2.828.586 3.414.326.327.764.471 1.414.535V19.5a1.5 1.5 0 0 1 3 0V21h4v-1.5a1.5 1.5 0 0 1 3 0v1.45c.65-.065 1.088-.21 1.414-.536C19 19.828 19 18.886 19 17V7c0-.943 0-1.414-.293-1.707S17.943 5 17 5H7c-.943 0-1.414 0-1.707.293"
			clipRule="evenodd"
		/>
		<path d="M8.5 9a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm0 3a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm0 3a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm7.5 4.5a.5.5 0 0 0-1 0zm-1 0V21h1v-1.5zm-6 0a.5.5 0 0 0-1 0zm-1 0V21h1v-1.5z" />
	</svg>
)
export default SvgSyForm
